/**
 * Whether this browser can render the game at all.
 *
 * Checked before mounting the canvas: without it, a browser with no WebGL shows a blank
 * black rectangle and no explanation, which the app-shell spec forbids.
 */

export function isWebGLAvailable(): boolean {
  if (typeof document === 'undefined') return false;

  try {
    const canvas = document.createElement('canvas');
    const context =
      canvas.getContext('webgl2') ??
      canvas.getContext('webgl') ??
      canvas.getContext('experimental-webgl');

    return context !== null;
  } catch {
    // Some browsers throw rather than returning null when WebGL is blocked outright.
    return false;
  }
}
